// #region Imports

import * as $ from 'jquery';
import * as AutoLoadOnScroll from './navigation/autoLoadOnScroll';
import * as BrowserHistory from './helpers/browserHistory';

// #endregion Imports

// #region Exports

export function initialize($element?: any): void {
    bindButtons($element);
}

// #endregion Exports

// #region Private constants

const buttonSelector = '.js-load-more[data-url]';

// #endregion Private constants

// #region Private functions

function bindButtons($element?: any): void {
    if ($element && $element.length) {
        $element.on('click', handleClick);
        return;
    }

    $(buttonSelector).on('click', handleClick);
}

function handleClick(event): void {
    event.preventDefault();

    const $this = $(this);
    const targetSelector = $this.data('target');
    const $target = $(targetSelector);
    const triggerSelector = $this.data('trigger');
    const $trigger = $(triggerSelector);
    const $divider = $trigger.find('.module__view-more-divider');

    $divider.addClass('module__view-more-divider--loading');

    if (!$this.hasClass('js-no-history')) {
        BrowserHistory.replaceEntry(event.target.href);
    }

    $.get(event.target.dataset.url,
        (data) => {
            $divider.removeClass('module__view-more-divider--loading');

            const $data = $(`<div>${data}</div>`);

            $target
                .append(
                    $data.find(targetSelector).children()
                );

            const $dataTrigger = $data.find(triggerSelector);

            if ($dataTrigger.length === 1) {
                $(triggerSelector)
                    .html($dataTrigger.html())
                    .find(buttonSelector)
                        .on('click', handleClick);
            } else {
                $(triggerSelector).remove();
            }

            AutoLoadOnScroll.initialize();
        });
}

// #endregion Private functions